import type { Achievement } from "../achievement.types";
import { freeMoves } from "../moveHistory";

export const notAllWhoWanderAreLostAchievement: Achievement = {
  id: "notAllWhoWanderAreLost",
  name: "Not All Who Wander Are Lost",
  icon: "compass-outline",
  description:
    "Finished a game with no Global or Local Optimal move before the last.",
  isProgressive: true,
  // Every move but a winning click, backtracked ones included.
  // A give-up counts as well as a win; only the final winning move may be Local Optimal.
  check: (gameReport, gameStatus) => {
    if (!gameReport || !["won", "given_up"].includes(gameStatus)) return false;
    const moves = freeMoves(gameReport, gameStatus);
    // Must have made at least one move that is subject to the check
    if (moves.length === 0) return false;
    return moves.every((m) => !m.isGlobalOptimal && !m.isLocalOptimal);
  },
};
